export enum ANCHORS {
  familyManagement = '#familyManagement',
  keysGeneration = '#keysGeneration',
}
